import { DataTableColumn } from "mantine-datatable";
import { useMemo } from "react";

import { DatabaseMetadataPopover } from "../../../../../components/DatabaseMetadataPopover/DatabaseMetadataPopover.tsx";
import { TableData, TableRow } from "../../../../../components/Table/types.ts";
import { PaymentHistory } from "../../../../../types/paymentHistory.ts";
import { toLocalDate } from "../../../../../utils/date.ts";
import { toLocalNumber } from "../../../../../utils/number.ts";

interface Props {
  data: PaymentHistory | null | undefined;
}

export function usePaymentHistoryData({ data }: Props): TableData {
  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "dpd",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{ tableName: "Invoice", fieldName: "dpd" }}
        >
          DPD
        </DatabaseMetadataPopover>
      ),
      width: "125px",
    },
    {
      accessor: "date",
      title: "Date",
      width: "150px",
    },
    {
      accessor: "outstandingPrinciple",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "Invoice",
            fieldName: "totalAmountDue",
          }}
        >
          OSP
        </DatabaseMetadataPopover>
      ),
      width: "125px",
    },
    {
      accessor: "lateCharge",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "Invoice",
            fieldName: "lateCharge",
          }}
        >
          Late Charge
        </DatabaseMetadataPopover>
      ),
      width: "125px",
    },
    {
      accessor: "accountReceivables",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "Invoice",
            fieldName: "totalAccountReceivable",
          }}
        >
          AR
        </DatabaseMetadataPopover>
      ),
      width: "125px",
    },
    {
      accessor: "paidAmount",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{ tableName: "Invoice", fieldName: "totalPaid" }}
        >
          Paid Amount
        </DatabaseMetadataPopover>
      ),
      width: "125px",
    },
  ];

  const rows = useMemo(() => {
    return data?.map((item) => {
      return {
        dpd: toLocalNumber(item.dpd),
        date: toLocalDate(item.date),
        outstandingPrinciple: toLocalNumber(item.outstandingPrincipal),
        lateCharge: toLocalNumber(item.lateCharge),
        accountReceivables: toLocalNumber(item.accountReceivables),
        paidAmount: toLocalNumber(item.paidAmount),
      };
    });
  }, [data]);

  return [columns, rows];
}
